<template>
  <div class="container-fluid">

    <div class="row">
      <div class="col-sm-12 col-lg-12 mt-3">
        <div class="card">
          <div class="card-header">
            <h5><vue-feather type="clipboard"></vue-feather> Evaluaciones — Gobierno</h5>
          </div>
          <div class="card-body">

            <p class="lead">
              La sección <strong>Evaluaciones</strong> del perfil Gobierno constituye el módulo principal para registrar avances,
              métricas, evidencias y resultados vinculados con la implementación de instrumentos, programas, incentivos o acciones
              asociadas a la Plataforma de M&amp;E / Marketplace Bajío Verde.
            </p>

            <hr />

            <div class="row mt-4">

              <div class="col-md-6 mb-4">
                <div class="card h-100 border-left-primary shadow-sm">
                  <div class="card-body">
                    <h6 class="card-title text-primary">
                      <vue-feather type="edit-3" class="me-1"></vue-feather> Registro de seguimiento
                    </h6>
                    <p class="card-text">
                      Esta sección permite que las personas usuarias gubernamentales documenten información de cumplimiento y
                      seguimiento mediante formularios estructurados. Cada registro se asocia con:
                    </p>
                    <ul class="ps-3">
                      <li>Entidad federativa e institución responsable</li>
                      <li>Programa o instrumento</li>
                      <li>Periodo reportado e indicador</li>
                      <li>Valor de avance y evidencia documental</li>
                      <li>Estado de revisión</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-4">
                <div class="card h-100 border-left-success shadow-sm">
                  <div class="card-body">
                    <h6 class="card-title text-success">
                      <vue-feather type="bar-chart-2" class="me-1"></vue-feather> Uso de la información
                    </h6>
                    <p class="card-text">
                      La información capturada en Evaluaciones alimenta:
                    </p>
                    <ul class="ps-3">
                      <li>Reportes agregados y tableros de visualización</li>
                      <li>Ejercicios de aprendizaje institucional</li>
                      <li>Procesos de toma de decisiones</li>
                      <li>Análisis de brechas y cadenas de valor</li>
                      <li>Evaluación de instrumentos y mejora continua de la Hoja de Ruta</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-4">
                <div class="card h-100 border-left-info shadow-sm">
                  <div class="card-body">
                    <h6 class="card-title text-info">
                      <vue-feather type="shield" class="me-1"></vue-feather> Trazabilidad y folio
                    </h6>
                    <p class="card-text">
                      Para asegurar trazabilidad, cada envío genera un <strong>folio interno</strong> y registra automáticamente:
                      usuario, fecha de carga y estado de revisión.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-4">
                <div class="card h-100 border-left-warning shadow-sm">
                  <div class="card-body">
                    <h6 class="card-title text-warning">
                      <vue-feather type="lock" class="me-1"></vue-feather> Seguridad y confidencialidad
                    </h6>
                    <p class="card-text">
                      El módulo opera bajo criterios de seguridad y confidencialidad, diferenciando entre información:
                    </p>
                    <ul class="ps-3">
                      <li><span class="badge bg-success">Pública</span></li>
                      <li><span class="badge bg-warning text-dark">Restringida</span></li>
                      <li><span class="badge bg-danger">Interna</span></li>
                    </ul>
                    <p class="card-text mt-2">
                      La información validada podrá ser utilizada para reportabilidad institucional.
                    </p>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "EvaluacionesIntro",
};
</script>
